
function Directive (){
    return {
        restrict: 'E',
        template: require('./listHeader.jade')
    }
}

export default Directive;


// WEBPACK FOOTER //
// ./app/common/widgets/listHeader.js